<template>
    <b-container style="padding-right:125px">

      <div class="home">
          <b-container fluid>
              <div id="pgTitle" tabindex="-1"><h1>{{pageTitle}}</h1></div>
              <b-row v-if="showInfo">


                <div v-if="false">
                  <b-col cols="12" class="mt-4">
                    <b-spinner variant="primary" label="Preparing form."></b-spinner>
                    <span class="h5 ml-2" style="display: inline;">Preparing your form...</span>
                  </b-col>
                </div>

              </b-row>


              <b-row v-else-if="!dataEntryComplete && !showInfo">
                  <b-col>
                    <strong>Please overwrite or add demographic information as needed. Save, then choose 'Next' to complete contact information.</strong>
                      <form-wizard ref="wizard"
                          :stepSize="stepSize"
                          :nextButtonText="'Next'"
                          :backButtonText="'Previous'"
                          :finishButtonText="'Finish'"
                          color="#003865"
                          :layout="layout"
                          id="wizard"
                          @on-complete="onComplete"
                          @on-change="switchTabs">
                          <span slot="title" tabindex="-1"/>
                          <b-alert v-model="showErrorSaving" variant="danger" dismissible>
                                {{saveErrorMessage}}
                          </b-alert>
                          <template slot="step" slot-scope="props">
                            <wizard-step :tab="props.tab"
                            :transition="props.transition"
                            :key="props.tab.title"
                            :index="props.index">
                            </wizard-step>
                          </template>

                          <tab-content :title="'Plan'" id="tabme-1"
                              :before-change="()=>validateStep('plan')"
                              :after-change="()=>scrollTo()">
                              <Plan ref="plan" @mergeOriginal="mergeOriginal" @on-validate="mergePartialModels"/>
                          </tab-content>

                          <tab-content :title="'Contact'" id="tabme-2"
                                      :before-change="()=>validateStep('contact')"
                                      :after-change="()=>scrollTo()">
                            <Contact ref="contact" @proceed="proceed" @skipToFinish="skipToFinish" @mergeOriginal="mergeOriginal" @on-validate="mergePartialModels"/>
                          </tab-content>

                          <tab-content :title="'Submit'" id="tabme-3" >
                            <Dropzone ref="dropzone"/>
                          </tab-content>

                          <!-- <template v-if="currentTab===1" slot="custom-buttons-right" slot-scope="props">
                            <wizard-button
                                style="background-color: rgb(0, 56, 101); border-color: rgb(0, 56, 101); color: white;"
                                @click.native="skipToFinish"
                            >Finish</wizard-button>
                          </template> -->
                          <template slot="footer" slot-scope="props">
                            <b-modal id="modal-save-changes" size="lg" no-close-on-backdrop hide-footer scrollable @hide="reset(props)">
                                  <h2>Save Changes?</h2>
                                  <hr/>
                                    <div>
                                      <b-row>
                                        <b-col cols="12">
                                            <p> You have unsaved changes. If you continue without saving, you will lose your changes.</p>
                                        </b-col>
                                      </b-row>
                                    </div>

                                      <b-row style="padding-top: 10px;">
                                        <b-col>
                                          <b-button :disabled="false" :hidden="false" @click="saveAndClose()" variant="primary" style="margin-right:15px;">Save Changes</b-button>
                                          <b-button @click="close" style="margin-right:15px;">Discard Changes</b-button>
                                        </b-col>
                                      </b-row>
                            </b-modal>
                               <div style="max-width: 125px;">
                               <wizard-button tabindex="0" v-if="props.activeTabIndex > -1" @click.native="goToPrev(props)" :style="props.fillButtonStyle" class="command-button">Previous</wizard-button>


                               <wizard-button tabindex="0" ref="saveButton" aria-live="assertive" aria-atomic="true" v-if="!props.isLastStep" @click.native="saveAll()" class="command-button" :style="props.fillButtonStyle">{{saveMessage}}</wizard-button>

                               <wizard-button tabindex="0" v-if="!props.isLastStep" @click.native="props.nextTab()" class="command-button" :style="props.fillButtonStyle">Next</wizard-button>
                               <wizard-button tabindex="0" v-else @click.native="onComplete()" class="command-button" :style="props.fillButtonStyle">  {{props.isLastStep ? 'Finish' : 'Next'}}</wizard-button>
                                </div>

                          </template>
                      </form-wizard>
                  </b-col>
              </b-row>

              <b-container v-else>

                <b-row>
                  <b-col>
                    <h1 class="text-center" v-if="skipSurvey">Thank you</h1>
                    <h1 v-else class="text-center">Thank you</h1>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <p class="h5 mb-4 text-center">Thank you for updating your company demographic and contact information and submitting your Health Plan Financial and Statistical Report as required by Minnesota Statutes 62J.38.</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col v-if="false">
                    <p class="h5 mb-4" v-if="!submittedSuccessfully">Unfortunately, there was an error saving your data.</p>
                    <p class="h5 mb-4" v-if="submittedSuccessfully">You may now upload a file. Please click the button below to continue to the upload page.</p>
                    <b-button variant="primary" v-if="submittedSuccessfully" v-on:click="goToDropzone()">Upload file</b-button>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <p class="h5 mb-4 mt-4 text-center">
                     If you have any questions please contact us at <a href="mailto:health.drmreport@state.mn.us">health.drmreport@state.mn.us</a>.
                     </p>
                  </b-col>
                </b-row>

              </b-container>

          </b-container>
      </div>
    </b-container>

</template>
<style>/** .wizard-card-footer { position: fixed; bottom: 12px; width: 73%; }**/</style>
<style>.wizard-card-footer { position: fixed; bottom: 55px; right: 10px;}</style>
<script>
import LocalStorageService from '@/common/LocalStorageService';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import Plan from '@/components/Plan'
import Contact from '@/components/Contact'
import Dropzone from '@/components/Dropzone'
import moment from 'moment'
import lambdaURL from '../lambda'

export default {
  components: {
      Plan,
      Contact,
      Dropzone
  },

  data: () => ({
      pageTitle: '',
      stepSize: 'sm',
      layout: '',
      showInfo: false,
      dataEntryComplete: false,
      skipSurvey: false,
      submittedSuccessfully: null,
      //shortCode: '',
      finalModel: {},
      defaultModel: {},
      originalModel: {},
      form: { },
      currentTab: 0,
      showSkipToFinish: false,
      showErrorSaving: false,
      saveErrorMessage: '',
      saveMessage: 'Save',
      saveChanges: false,
      backToSearch: false,
      clickedDiscard: false,
      movingToPrev: false,
      stayingOnPage: false
  }),

  created() {
      document.title = 'HEP Data Portal - Demographics Form'
      this.pageTitle = document.title
      /**this.token = this.$route.params.token
      lambdaURL.getDemography('123').then((res) => {
                  this.$data.planData = res;
                  })
                  .catch((err) => {
                  })**/
  },

  computed: {
    email() {
        return this.finalModel.emailAddress
      },
  },

  methods: {
    goToPrev(props) {
        //console.log("gotoPrev")
        //console.log(props.activeTabIndex)
        if (props.activeTabIndex === 0) {
            if (this.validateStep('plan')) {
                if (this.checkIfChanged()) {
                    this.backToSearch = true;
                    this.saveOrDiscardChanges();
                } else {
                    window.location.replace('/search');
                }
            }
        } else {
            if (this.validateStep('contact')) {
                this.movingToPrev = true;
                props.prevTab()
            }
        }
    },
    startSurvey(){
      this.showInfo=false
      this.switchTabs(-1,0)
    },
    showInfoPage(){
      this.showInfo=false
      this.dataEntryComplete=true
      this.skipSurvey = true
      this.switchTabs(-1,-1)
    },
    switchTabs(prevIdx, nextIdx) {
        if (nextIdx > prevIdx) {
            this.movingToPrev = false
        }
        this.saveOrDiscardChanges();
        if (nextIdx === 1) {
            if (this.stayingOnPage !== true) {
                this.resetContactsEditable();
                //clear any messages from files on dropzone
                this.clearMessage();
            }
            this.stayingOnPage = false
        }
        var title = 'Welcome'
        switch (nextIdx) {
            case -1:
              title = 'Info'
              break;
            case 0:
              title = 'Plan'
                break;
            case 1:
              title = 'Contact Information'
              break;
            case 2:
              title = 'Submit'
                break;
            default:
                title = 'Finished'
        }
        document.title = title + ' - HEP Data Portal'
        this.pageTitle = document.title
        document.getElementById('pgTitle').focus()
    },

    validateStep(name) {
      var refToValidate = this.$refs[name];
      //console.log('refs name: ' + this.$refs[name]);
      //console.log('company name: ' + name);
      //console.log('refVal: ' + refToValidate);
      return refToValidate.validate();
    },

    proceed() {
        this.$refs.wizard.nextTab();
    },

    skipToFinish() {
         this.validateStep('contact')
         this.$refs.wizard.changeTab(this.currentTab,3)
         this.onComplete()
    },

    mergeOriginal(model) {
        this.defaultModel = Object.assign({}, this.defaultModel, model)
        this.originalModel = JSON.parse(JSON.stringify(this.defaultModel))
    },

    checkIfChanged() {
        this.validateStep('plan')
        this.validateStep('contact')

        var planChanged = false
        var newPlanData = JSON.parse(JSON.stringify(this.finalModel.planData))
        newPlanData.phone = newPlanData.phone.replaceAll('-', '')
        newPlanData.fax = newPlanData.fax.replaceAll('-', '')
        newPlanData.mailCity = newPlanData.mailCity.toUpperCase()
        newPlanData.mailCounty = newPlanData.mailCounty.toUpperCase()

        var oldPlanData = JSON.parse(JSON.stringify(this.originalModel.planData))
        oldPlanData.phone = oldPlanData.phone.replaceAll('-', '')
        oldPlanData.fax = oldPlanData.fax.replaceAll('-', '')
        oldPlanData.mailCity = oldPlanData.mailCity.toUpperCase()
        oldPlanData.mailCounty = oldPlanData.mailCounty.toUpperCase()

        for (var item in newPlanData) {
          if (newPlanData[item] !== oldPlanData[item] && !(JSON.stringify(newPlanData[item]) === JSON.stringify(oldPlanData[item])) ) {
            //console.log(newPlanData[item])
            //console.log(oldPlanData[item])
            planChanged = true
          }
        }

        var contactChanged = false
        //console.log(this.finalModel.contact)
        var newContactData = JSON.parse(JSON.stringify(this.finalModel.contact))
        newContactData.preparePhone = newContactData.preparePhone.replaceAll('-', '')
        newContactData.phoneExt = newContactData.phoneExt.replaceAll('-', '')
        newContactData.prepareFax = newContactData.prepareFax.replaceAll('-', '')
        newContactData.prepareSupPhone = newContactData.prepareSupPhone.replaceAll('-', '')
        newContactData.prepareCity = newContactData.prepareCity.toUpperCase()
        newContactData.prepareCounty = newContactData.prepareCounty.toUpperCase()

        var oldContactData = JSON.parse(JSON.stringify(this.originalModel.contact))
        oldContactData.preparePhone = oldContactData.preparePhone.replaceAll('-', '')
        oldContactData.phoneExt = oldContactData.phoneExt.replaceAll('-', '')
        oldContactData.prepareFax = oldContactData.prepareFax.replaceAll('-', '')
        oldContactData.prepareSupPhone = oldContactData.prepareSupPhone.replaceAll('-', '')
        oldContactData.prepareCity = oldContactData.prepareCity.toUpperCase()
        oldContactData.prepareCounty = oldContactData.prepareCounty.toUpperCase()

        for (var contactItem in newContactData) {
          if (newContactData[contactItem] !== oldContactData[contactItem] && !(JSON.stringify(newContactData[contactItem]) === JSON.stringify(oldContactData[contactItem])) ) {
            contactChanged = true
            //console.log(oldContactData[contactItem])
            //console.log(newContactData[contactItem])
          }
        }
        
        var CC1Changed = false
        if (this.finalModel.showCC1 !== this.originalModel.showCC1) {
            CC1Changed = true
        } else {
            var newCC1Data = JSON.parse(JSON.stringify(this.finalModel.courtesyContact))
            newCC1Data.preparePhone = newCC1Data.preparePhone.replaceAll('-', '')
            newCC1Data.phoneExt = newCC1Data.phoneExt.replaceAll('-', '')
            newCC1Data.prepareFax = newCC1Data.prepareFax.replaceAll('-', '')
            newCC1Data.prepareCity = newCC1Data.prepareCity.toUpperCase()
            newCC1Data.prepareCounty = newCC1Data.prepareCounty.toUpperCase()
            var oldCC1Data = JSON.parse(JSON.stringify(this.originalModel.courtesyContact))
            //oldCC1Data.prepareZip = oldCC1Data.prepareZip.replaceAll('-', '')
            oldCC1Data.preparePhone = oldCC1Data.preparePhone.replaceAll('-', '')
            oldCC1Data.phoneExt = oldCC1Data.phoneExt.replaceAll('-', '')
            oldCC1Data.prepareFax = oldCC1Data.prepareFax.replaceAll('-', '')
            oldCC1Data.prepareCity = oldCC1Data.prepareCity.toUpperCase()
            oldCC1Data.prepareCounty = oldCC1Data.prepareCounty.toUpperCase()
            for (var CC1Item in newCC1Data) {
              if (!(JSON.stringify(newCC1Data[CC1Item]) === JSON.stringify(oldCC1Data[CC1Item])) ) {
                CC1Changed = true
                if (JSON.stringify(oldCC1Data[CC1Item] != null)) { console.log(JSON.stringify(oldCC1Data[CC1Item])) }
                if (JSON.stringify(newCC1Data[CC1Item] != null)) { console.log(JSON.stringify(newCC1Data[CC1Item])) }
              }
            }
        }
        
        var CC2Changed = false
        if (this.finalModel.showCC2 !== this.originalModel.showCC2) {
            CC2Changed = true
        } else {
            var newCC2Data = JSON.parse(JSON.stringify(this.finalModel.courtesyContact2))
            newCC2Data.preparePhone = newCC2Data.preparePhone.replaceAll('-', '')
            newCC2Data.phoneExt = newCC2Data.phoneExt.replaceAll('-', '')
            newCC2Data.prepareFax = newCC2Data.prepareFax.replaceAll('-', '')
            newCC2Data.prepareCity = newCC2Data.prepareCity.toUpperCase()
            newCC2Data.prepareCounty = newCC2Data.prepareCounty.toUpperCase()
            var oldCC2Data = JSON.parse(JSON.stringify(this.originalModel.courtesyContact2))
            oldCC2Data.preparePhone = oldCC2Data.preparePhone.replaceAll('-', '')
            oldCC2Data.phoneExt = oldCC2Data.phoneExt.replaceAll('-', '')
            oldCC2Data.prepareFax = oldCC2Data.prepareFax.replaceAll('-', '')
            oldCC2Data.prepareCity = oldCC2Data.prepareCity.toUpperCase()
            oldCC2Data.prepareCounty = oldCC2Data.prepareCounty.toUpperCase()
            for (var CC2Item in newCC2Data) {
              if (!(JSON.stringify(newCC2Data[CC2Item]) === JSON.stringify(oldCC2Data[CC2Item])) ) {
                if (JSON.stringify(oldCC2Data[CC2Item] != null)) { console.log(JSON.stringify(oldCC2Data[CC2Item])) }
                if (JSON.stringify(newCC2Data[CC2Item] != null)) { console.log(JSON.stringify(newCC2Data[CC2Item])) }
                CC2Changed = true
              }
            }
        }

        return (planChanged || contactChanged || CC1Changed || CC2Changed);
    },

    saveAll() {
        this.saveMessage = 'Saving'
        if (this.validateStep('plan') && this.validateStep('contact')) {
        /**delete this.finalModel.defaultItem
        delete this.finalModel.defaultContact**/
        //console.log('Saving Now.');
        this.originalModel.planData = JSON.parse(JSON.stringify(this.finalModel.planData))
          //console.log('final planData name: ' + this.finalModel.planData.name);
        this.originalModel.contact = JSON.parse(JSON.stringify(this.finalModel.contact))
        this.originalModel.courtesyContact = JSON.parse(JSON.stringify(this.finalModel.courtesyContact))
        this.originalModel.showCC1 = this.finalModel.showCC1
        this.originalModel.courtesyContact2 = JSON.parse(JSON.stringify(this.finalModel.courtesyContact2))
        this.originalModel.showCC2 = this.finalModel.showCC2

        const courtesyContactsRepresentation = []
        if (this.finalModel.showCC1) {
                    courtesyContactsRepresentation.push(this.finalModel.courtesyContact)
        }
        if (this.finalModel.showCC2) {
                    courtesyContactsRepresentation.push(this.finalModel.courtesyContact2)
        }
        const payload = {saveDemographyRequest: {
            demographyRepresentation: this.finalModel.planData,
            contactRepresentation: this.finalModel.contact,
            courtesyContactsRepresentation: courtesyContactsRepresentation
        }}
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/saveDemography`, payload)
        .then(response => {
            this.showErrorSaving = false;
            this.saveMessage = 'Save';
            //(response.statusText);
            //console.log('message: ' + response.data);
            if (response.data === 'error') {
                this.showErrorSaving = true;
                this.saveErrorMessage = 'Please check all input values (* = required).';
            }
        })
        .catch(e => {
            console.log(e);
            this.showErrorSaving = true;
            this.saveErrorMessage = "Error saving."
        });

        }
        else {
            this.showErrorSaving = true;
            this.saveErrorMessage = "At least one field is invalid or a mandatory field is empty. Please correct errors and try again.";
        }
    },

    saveOrDiscardChanges() {
        if (this.checkIfChanged()) {
            this.$bvModal.show('modal-save-changes')
        }
    },

    saveAndClose() {
        this.saveChanges = true;
        this.saveAll();
        this.close();
    },

    close() {
        this.clickedDiscard = true
        this.$bvModal.hide('modal-save-changes')
    },

    reset(props) {
        if (!this.saveChanges) {
            this.$refs.plan.planData = JSON.parse(JSON.stringify(this.originalModel.planData))
            this.$refs.contact.contact = JSON.parse(JSON.stringify(this.originalModel.contact))
            this.$refs.contact.courtesyContact = JSON.parse(JSON.stringify(this.originalModel.courtesyContact))
            this.$refs.contact.showCC1 = this.originalModel.showCC1
            this.$refs.contact.courtesyContact2 = JSON.parse(JSON.stringify(this.originalModel.courtesyContact2))
            this.$refs.contact.showCC2 = this.originalModel.showCC2
            if (!(this.validateStep('plan')) || !(this.validateStep('contact'))) {
                this.clickedDiscard = false; //if the original data is not valid, then discarding changes and moving away from the current step is not allowed
            }
        }
        if (!this.clickedDiscard) {
            this.stayingOnPage = true //if clicked x instead of discard, the selected contacts edits are not reset because after the pop up closes it will go back to the contacts tab
            if (this.movingToPrev === true && this.backToSearch === false) {
                props.nextTab() //clicking next or previous automatically changes the tab, so if not allowed to move or clicked x, then doing the opposite goes back to current tab
            } else {
                props.prevTab()
            }
        }
        if (this.backToSearch) {
            if (this.clickedDiscard || this.saveChanges) {
                window.location.replace('/search');
            }
        }
        this.saveChanges = false
        this.movingToPrev = false
        this.clickedDiscard = false
        this.backToSearch = false
    },

    resetContactsEditable() {
        this.$refs.contact.keepDisabled = true;
        this.$refs.contact.selectedEdit = '';
        this.$refs.contact.keepDisabledCC1 = true;
        this.$refs.contact.selectedEditCC1 = '';
        this.$refs.contact.keepDisabledCC2 = true;
        this.$refs.contact.selectedEditCC2 = '';
    },
      clearMessage: function() {
          document.getElementById('file').innerHTML = '';
          document.getElementById('message').innerHTML = '';
          document.getElementById('invalidFile').innerHTML = '';
          document.getElementById('errorMessage').innerHTML = '';
          document.getElementById('validDataFileMessageId').innerHTML = '';
          document.getElementById('validDataFileId').innerHTML = '';
          document.getElementById('notDataFileMessageId').innerHTML = '';
          document.getElementById('notDataFileId').innerHTML = '';
          document.getElementById('invalidDataFileMessageId').innerHTML = '';
          document.getElementById('invalidDataFileId').innerHTML = '';
          document.getElementById('unknownDataFileMessageId').innerHTML = '';
          document.getElementById('unknownDataFileId').innerHTML = '';
      },

    mergePartialModels(model, isValid) {
      if(isValid){
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model)
        //console.log('final model')
        //console.log(this.finalModel)
      }
    },

    onComplete() {
        document.title = 'Thank you ' + ' - HEP Data Portal'
        this.pageTitle = document.title
        //this.finalModel.code = this.randomString(8)
        //this.shortCode = this.finalModel.code

        /**delete this.finalModel.defaultItem
        delete this.finalModel.defaultContact**/

        /**this.finalModel.preferredLanguage = this.$root.$i18n.local**/

        /**const courtesyContactsRepresentation = [this.finalModel.courtesyContact]
        if (this.finalModel.showCC2) {
                    courtesyContactsRepresentation[1] = (this.finalModel.courtesyContact2)
                }
        const payload = {saveDemographyRequest: {
            demographyRepresentation: this.finalModel.planData,
            contactRepresentation: this.finalModel.contact,
            courtesyContactsRepresentation: courtesyContactsRepresentation
        }}

        axios.post(`${process.env.VUE_APP_API_BASE_URL}/saveDemography`, payload)
        .then(response => {
            this.submittedSuccessfully = true;
        })
        .catch(e => {
            console.log(e);
            this.submittedSuccessfully = false;
        });**/

        this.dataEntryComplete = true
    },

    goToDropzone() {
         window.location.replace('/dropzone')
     },

    /** randomString(len) {
        let text = ''
        let chars = "abcdefghijklmnopqrstuvwxyz0123456789"
        for (let i = 0; i < len; i++ ) {
            text += chars.charAt(Math.floor(Math.random() * chars.length))
        }
        return text.toUpperCase()
    }, **/

    scrollTo() {
        let elem = document.getElementById("wizard")
        elem.scrollIntoView()
        window.scrollTo(0,0)
    },

     resizeThrottler() {
      var resizeTimeout;
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(() => {
          resizeTimeout = null;
          this.sizeHandler();
          // The actualResizeHandler will execute at a rate of 15fps
        }, 66);
      }
    },
    sizeHandler() {
      let w = window.innerWidth
      this.layout = ""
      if (w < 750) {
        this.stepSize = "xs"
        //this.layout = "vertical"
      } else if (w > 750 && w < 1000) {
        this.stepSize = "xs"
      } else {
        this.stepSize = "sm"
      }
    },
    fixTabOrder() {
      this.$nextTick(function () {
        var steps = document.querySelectorAll("div[role='tab']")
        steps.forEach(step => {
            step.setAttribute("tabindex", "-1")
        })

        var steps2 = document.querySelectorAll(".wizard-nav-pills>li>a");
         steps2.forEach(step => {
            step.setAttribute("tabindex", "-1")
        })
      })
    }
  },
  mounted() {
    window.addEventListener("resize", this.resizeThrottler, false);
    this.sizeHandler()
    this.fixTabOrder()
    //this.currentTab = this.$refs.wizard.activeTabIndex
  },
  updated: function() {
      this.fixTabOrder()
      //this.currentTab = this.$refs.wizard.activeTabIndex
  },


}
</script>

<style>
@media only screen and (max-width: 750px) {
  .vue-form-wizard .wizard-nav {
        display: none !important;
    }
    .vue-form-wizard .wizard-nav-pills {
        display: none !important;
    }
    .vue-form-wizard.sm .wizard-navigation .wizard-progress-with-circle {
        display: none !important;
    }

    .vue-form-wizard .wizard-btn {
        min-width: 120px !important;
    }

    .container {
        padding-right: 5px;
        padding-left: 5px;
    }

    .container-fluid {
        padding-right: 5px;
        padding-left: 5px;
    }
}

.vue-form-wizard .wizard-nav-pills>li.active>a .wizard-icon {
    color: white !important;
    pointer-events: none !important;
}

.vue-form-wizard .wizard-nav-pills > li > a {
    pointer-events: none !important;
    color: #737373 !important;
}

.vue-form-wizard.sm .wizard-icon-circle {
    color: #737373 !important;
}

.stepTitle active {
    color: rgb(0, 56, 101) !important;
}

.stepTitle inactive{
    color: #737373 !important;
}

wizard-icon-circle md {
    min-height: 100px;
    padding: 30px 20px 10px;
    margin-bottom: 36px;
    color: #737373 !important;
    outline-color: #737373 !important;
}


.vue-form-wizard .wizard-icon-circle {
    color: #737373 !important;
    border: 3px solid #003865 !important;
}

.wizard-title {
    display: none;
}

button {
  margin-right: 0px;
}

.command-button {
    color: white;
    background-color: rgb(0, 56, 101) !important;
    margin-bottom: 5px !important;
}

.command-button:hover {
    color: white;
    background-color: rgb(13, 82, 87) !important;
}

.command-button:focus {
    color: white;
    background-color: rgb(13, 82, 87) !important;
}
</style>